<a [routerLink]="['/pictures']" [queryParams]="$queryParams()">
    <cm-button class="cm-action-button" (click)="activated.emit(true)">
        <ng-container cm-left-icon>
            <i class="far fa-images"></i>
        </ng-container>
        <ng-container cm-text> Show pictures</ng-container>
    </cm-button>
</a>
